import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/settings";
/**
 * reducer for changes to settings regarding mods
 */
export const settingsReducer = {
    reducers: {
        [actions.setInstallPath]: (state, payload) => {
            const { gameId, path } = payload;
            return setSafe(state, ["installPath", gameId], path);
        },
        [actions.setInstallPathMode]: (state, payload) => setSafe(state, ["installPathMode"], payload),
        [actions.setSuggestInstallPathDirectory]: (state, payload) => setSafe(state, ["suggestInstallPathDirectory"], payload),
        [actions.setActivator]: (state, payload) => {
            const { gameId, activatorId } = payload;
            return setSafe(state, ["activator", gameId], activatorId);
        },
        [actions.setShowModDropzone]: (state, payload) => setSafe(state, ["showDropzone"], payload),
        [actions.setConfirmPurge]: (state, payload) => setSafe(state, ["confirmPurge"], payload),
        [actions.setCleanupOnDeploy]: (state, payload) => setSafe(state, ["cleanupOnDeploy"], payload),
    },
    defaults: {
        installPath: {},
        installPathMode: "userData",
        suggestInstallPathDirectory: "Vortex Mods",
        modlistState: {},
        activator: {},
        showDropzone: true,
        confirmPurge: true,
        cleanupOnDeploy: false,
    },
    verifiers: {
        installPath: {
            // shouldn't be possible
            description: () => "Severe! Invalid set of staging folders",
            elements: {
                _: {
                    description: () => "Severe! A mod staging folder was corrupted and has to be reset",
                    type: "string",
                },
            },
        },
    },
};
